module.exports = __webpack_public_path__ + "Roboto-ThinItalic.21e9a2e5ed0b0d8d1bb7.svg";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.svg
// module chunks = 5